export const SUBC_WX_MSG = '/app/task/prom_subc_wx_msg.cgi';
export const PROM_SUBC_WX_MSG_V2 = '/app/promotion/task/prom_subc_wx_msg_v2.cgi';
export const PROM_QRY_SUBC_WX_MSG = '/app/promotion/task/prom_qry_subc_wx_msg.cgi';
export const GEN_SHARE_SHORTURL = '/app/promotion/prom_gen_share_shorturl.cgi';
export const APPID_JSAPI_SIGN = '/app/promotion/appid_jsapi_signature.cgi';
export const PROM_USER_DEFAULTHK = '/app/promotion/prom_user_defaulthk.cgi';
export const JSAPI_SIGNATURE = '/app/promotion/jsapi_signature.cgi';
